import config from '../config';
import i18n from '@/i18n';

const { ANALYTICS_VARIABLES } = config;

const internal = {
  lastPage: null,
  formFields: {},
  lastTrigger: 0,
  getTracker() {
    // eslint-disable-next-line no-underscore-dangle
    return window._satellite || null;
  },
  getDigitalData() {
    const pageInfo = ((window.digitalData || {}).webspecial || {}).pageInfo || {};
    return {
      webspecial: {
        siteInfo: {
          webspecialName: `${ANALYTICS_VARIABLES.ENTITY_NAME}`,
          // webspecialPhase: `${ANALYTICS_VARIABLES.ENTITY_PHASE}`,
          language: i18n.locale,
          viewport: `${window.innerWidth}px`,
        },
        pageInfo: {
          pageName: pageInfo.pageName || null,
          scrollingDepth: 0,
        },
        dealerID: 'CID546655',
        formFail: false,
        formFields: internal.parseFormFields(),
      },
    };
  },
  parseFormFields(ref, isValid, value = null) {
    const out = [];
    if (ref) {
      internal.formFields[ref] = {
        valid: isValid,
        value,
      };
    }
    const keys = Object.keys(internal.formFields);
    keys.forEach((key) => {
      const field = internal.formFields[key];
      if (field.valid) {
        out.push(`${key}${(field.value !== null) ? `_${field.value}` : ''}`);
      }
    });
    return out.join('|');
  },
};

export default {
  trackPage(values) {
    const tracker = internal.getTracker();
    if (tracker) {
      const digitalData = internal.getDigitalData();
      digitalData.webspecial.pageInfo.pageName = values.page;
      window.digitalData = digitalData;
      tracker.pageBottom();
    }
  },
  resetFormFields() {
    internal.formFields = {};
  },
  trackFormField(ref, value, isValid) {
    const tracker = internal.getTracker();
    if (tracker) {
      const digitalData = internal.getDigitalData();
      digitalData.webspecial.formFail = false;
      digitalData.webspecial.formFields = internal.parseFormFields(ref, value, isValid);
      window.digitalData = digitalData;
    }
  },
  trackFormError() {
    const tracker = internal.getTracker();
    if (tracker) {
      const digitalData = internal.getDigitalData();
      digitalData.webspecial.formFail = true;
      digitalData.webspecial.formFields = internal.parseFormFields();
      window.digitalData = digitalData;
    }
  },
  trackScrollDepth() {
    const tracker = internal.getTracker();
    if (tracker) {
      const { scrollTop, scrollHeight } = document.documentElement;
      const triggers = [25, 50, 75, 100];
      const percentage = ((scrollTop + window.innerHeight / 2) / (scrollHeight - window.innerHeight)) * 100;
      const digitalData = internal.getDigitalData();
      const pageName = digitalData.webspecial.pageInfo.pageName;
      if (internal.lastPage !== pageName) {
        internal.lastTrigger = 0;
        internal.lastPage = pageName;
        digitalData.webspecial.pageInfo.scrollingDepth = 0;
        window.digitalData = digitalData;
      }
      for (let i = triggers.length - 1; i >= 0; i -= 1) {
        const trigger = triggers[i];
        if (percentage > trigger && internal.lastTrigger < trigger) {
          internal.lastTrigger = trigger;
          digitalData.webspecial.pageInfo.scrollingDepth = trigger;
          window.digitalData = digitalData;
          break;
        }
      }
    }
  },
};
